module.exports = __webpack_public_path__ + "img/cloudability.b096ae26.png";